import React from 'react'
import CommonUtils from '../../utils/commonUtils'
import TextUtils from '../../utils/textUtils'

class JobMetadataModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  createFileList() {
    const {currentFile, currentFilePart} = this.props
    return this.props.files.map((file) => {
      let isCurrentFile =
        (currentFile && currentFile === file.id) ||
        (currentFilePart && currentFilePart === file.id)

      let currentClass = isCurrentFile ? 'current' : ''
      currentClass =
        this.props.files.length === 1 || isCurrentFile
          ? currentClass + ' active'
          : currentClass
      if (file.metadata && file.metadata.instructions) {
        return (
          <div key={'file' + file.id}>
            <div className={'title ' + currentClass}>
              <i className="dropdown icon" />
              <span
                title={file.file_name}
                className={
                  'fileFormat ' +
                  CommonUtils.getIconClass(
                    file.file_name.split('.')[
                      file.file_name.split('.').length - 1
                    ],
                  )
                }
              >
                {file.file_name}
              </span>
              {isCurrentFile && (
                <div className="current-icon">
                  <CurrentIcon />
                </div>
              )}
            </div>
            <div className={'content ' + currentClass}>
              <div
                className="transition"
                dangerouslySetInnerHTML={{
                  __html: this.getHtml(file.metadata.instructions),
                }}
              />
            </div>
          </div>
        )
      } else {
        return ''
      }
    })
  }

  createSingleFile() {
    const file = this.props.files.find(
      (file) => parseInt(file.id) === parseInt(this.props.currentFile),
    )
    return (
      <div className="matecat-modal-text">
        <div className={'description'}>
          <h3>Please read the following notes and references carefully:</h3>
        </div>
        <div className="instructions-container">
          <p
            dangerouslySetInnerHTML={{
              __html: this.getHtml(file.metadata.instructions),
            }}
          />
        </div>
      </div>
    )
  }

  getHtml(text) {
    return text
  }

  componentDidMount() {
    $(this.accordion).accordion()
    setTimeout(() => {
      const element = document.querySelector('.title.current.active')
      element && element.scrollIntoView({behavior: 'smooth'})
    }, 200)
  }

  render() {
    return (
      <div className="instructions-modal">
        <div className="matecat-modal-middle">
          {this.props.showCurrent ? (
            this.createSingleFile()
          ) : (
            <div className="matecat-modal-text">
              {this.props.projectInfo && (
                <div>
                  <h2>Project instructions</h2>
                  <div className="instructions-container">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: this.getHtml(this.props.projectInfo),
                      }}
                    />
                  </div>
                </div>
              )}
              {this.props.files &&
                this.props.files.find((file) => file.metadata.instructions) && (
                  <div>
                    <h2>File instructions</h2>
                    <div
                      className="ui styled fluid accordion"
                      ref={(acc) => {
                        this.accordion = acc
                      }}
                    >
                      {this.createFileList()}
                    </div>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default JobMetadataModal

const CurrentIcon = () => {
  return (
    <svg
      width={20}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 12"
    >
      <path
        fill="#777"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        d="M15.735.265a.798.798 0 00-1.13 0L5.04 9.831 1.363 6.154a.798.798 0 00-1.13 1.13l4.242 4.24a.799.799 0 001.13 0l10.13-10.13a.798.798 0 000-1.129z"
        transform="translate(-266 -10) translate(266 8) translate(0 2)"
      />
    </svg>
  )
}
